import React from 'react';

import { Svg, type SvgProps } from './svg';

export function PeakIcon(props: SvgProps) {
  return (
    <Svg data-testid="peak-icon" {...props}>
      <path d="M11.63 1.83 2.25 18h1.735l7.648-13.185 7.589 13.034 2.958-5.099h-1.733l-1.228 2.115-7.59-13.035Zm.014 5.992L6.61 16.5h1.736l3.3-5.693L18.02 21.75h1.736L11.644 7.822Z" />
    </Svg>
  );
}
